import Alert from '@/app/components/CustomAlertToast.vue'
import { useToast } from "vue-toastification";

export const toast = (model) => {
    const toastAlert = useToast();
    var configuration = {
        component: Alert,
        props: {
            ...model
        }
    }

    var options = { 
        position: "top-right",
        timeout: 6000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: false
    };

    switch(model.variant){
        case 'success':
            options.position = "top-right";
            toastAlert.success({...configuration}, 
                                {...options})
            break;
        case 'danger':
            toastAlert.error({...configuration}, 
                                  {...options})
                break;
        case 'warning':
            toastAlert.warning({...configuration}, 
                                  {...options})
                break;
    }
}

export const variant = {
    error: 'danger',
    success: 'success',
    warning: 'warning'
}

export const formatDate = (date) => {
    if(!date) return '--';
    const formatter = new Intl.DateTimeFormat('es-ES', {
        year: '2-digit', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
        hour12: false
      });

    return formatter.format(new Date(date));
}

export const formatDateWithoutHour = (date) => {
    if(!date) return '--';
    return new Date(date).toLocaleDateString();
}

export const formatMoney = (number) => {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return USDollar.format(number)
}

export const truncate = (text, maxLength) => {
    if (!text) return "--";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
}